import { useEffect } from 'react';
import { withRouter, matchPath } from 'react-router-dom'; // eslint-disable-line
import localStorageFallback from 'local-storage-fallback';
import {
  setUserId,
  setEmployee,
  setAccess,
  setLastVisitedArtist,
  sendPageview,
} from '../../../../shared/googleAnalytics';
import {
  useCurrentUser,
  useCurrentUserFeatures,
} from '../../../../shared/currentUser';

export const PageAnalytics = withRouter(function PageAnalytics({
  history,
  location,
}) {
  const currentUser = useCurrentUser();
  const features = useCurrentUserFeatures();
  const lastVisitedArtist = useLastVisitedArtist(location.pathname);
  const page = history.createHref(location);

  // set dimensions
  useEffect(() => {
    setUserId(
      (currentUser &&
        currentUser.partnerIds &&
        currentUser.partnerIds.google) ||
        '',
    );
    setEmployee(features['s4a-employee'] === 'Rollout');
    setAccess(currentUser ? currentUser.hasAccess : false);
    setLastVisitedArtist(lastVisitedArtist);
  }, [currentUser, features, lastVisitedArtist]);

  // send page view
  useEffect(() => {
    sendPageview(page);
  }, [page]);

  return null;
});

function useLastVisitedArtist(pathname = '/') {
  const currentUser = useCurrentUser();
  const username = currentUser ? currentUser.username : undefined;
  const key = `${username}:analytics:lastVisitedArtist`;

  let value = localStorageFallback.getItem(key) || '';

  const match = matchPath<{ artistId: string }>(pathname, {
    path: '/artist/:artistId',
  });

  if (match) {
    value = match.params.artistId;
  }

  useEffect(() => {
    if (!value) return;
    localStorageFallback.setItem(key, value);
  }, [key, value]);

  return value;
}
